import React from 'react';
import { Modal } from 'react-bootstrap';

function ErrorModal(props) {

    return (
        <Modal show={!!props.message}>

            <Modal.Header closeButton onHide={props.onClose}>
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.message}
            </Modal.Body>
        </Modal>
    );
}

export default ErrorModal;


// WEBPACK FOOTER //
// ./src/components/_global/ErrorModal.jsx